import { CommonModule, NgClass } from '@angular/common';
import { HostBinding, ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { SwatchComponentDef } from '@df/catalog-ui/product/swatch/swatch.component.def';
import { Client } from '@df/core/service/client';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { IProductViewDisplayColourPopupEvent, ProductViewLayoutComponent } from '../layout/product-view-layout.component';

@Component({
    standalone: true,
    imports: [NgClass, DfModuleImageModule, CommonModule],
    selector: 'product-view-swatch',
    templateUrl: './product-view-swatch.html',
    styleUrl: './product-view-swatch.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewSwatchComponent extends SwatchComponentDef {
    @Input()
    @HostBinding('class.disabled')
    disabled = false;

    @Input()
    zoom = false;

    @Input()
    title?: string;

    @Input()
    subtitle?: string;

    private client = inject(Client);

    private productViewLayoutComponent = inject(ProductViewLayoutComponent);

    protected get displayZoom(): boolean {
        if (this.zoom && this.swatch && this.getType() !== 'checkbox') {
            return this.client.sizeId > 1;
        }
        return false;
    }

    protected get altText(): string {
        if (this.title) {
            return this.title;
        }

        if (this.option && typeof this.option !== 'string') {
            return this.option.label?.toString() || '';
        }

        return '';
    }

    protected toggleZoom($event: MouseEvent, to: boolean): void {
        const element = $event.target as HTMLElement;
        if (element && this.swatch) {
            const event: IProductViewDisplayColourPopupEvent = {
                element,
                to,
                swatch: this.swatch,
                type: this.getType() as 'background' | 'image',
                title: this.title,
                subtitle: this.subtitle
            };
            this.productViewLayoutComponent.displayColourPopup(event);
        }
    }
}
